import { ISpaceRoute } from '../types';

export default function getPageRouteFromPath(
  routes: ISpaceRoute,
  path: string[],
): ISpaceRoute {
  if (path.length <= 0 || path[0] === '') {
    return routes;
  } if (path.length === 1) {
    const lastPath = path[0];
    return routes.children[lastPath];
  }
  const nextPath = path[0];
  const nextRoutes = routes.children[nextPath];
  const pathRest = [...path];
  pathRest.shift();
  return getPageRouteFromPath(nextRoutes, pathRest);
}
